import { notifyPurchaseStatusChange } from "../webhooks/notifyPurchaseStatusChange"
const webhooksPageContent = [
  {
    "content": "Webhooks",
    "type": "title"
  },
  {
    "type": "separator"
  },
  {
    "type": "text",
    "content": "Webhooks allow you to receive real-time notifications about purchase status changes. By setting up a webhook endpoint, you can automate processes such as updating order statuses, sending confirmation emails, or triggering other actions in your system when specific events occur."
  },
  {
    "type": "text",
    "content": "Webhook URL must be specified in draft creation request (<code>notification_url</code> field)."
  },
  {
    ...notifyPurchaseStatusChange,
    "anchor": "purchase-status"
  }
]

export default webhooksPageContent
